import UserProvider from './UserProvider';

export default UserProvider;
